module.exports = __webpack_public_path__ + "img/shipped.6c69fe12.svg";